import { CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { RenaultUserDTO } from '../models/renault-user-dto';
import { UserService } from '../services/user.service';
import { catchError, combineLatestWith, map, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class AuthGuard implements CanActivate {

  userModel: RenaultUserDTO;
  conditionsAccept: boolean;
  userR1: boolean;
  userR2Ok: boolean;

  constructor(private router: Router,
    private userService: UserService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {    
    const userInfo$ = this.userService.getUserInfo();
    const checkConditions$ = this.userService.CheckConditionsDistributor();
    const checkUserR1$ = this.userService.CheckUserDistributorR1();
    const checkUserR2Ok$ = this.userService.CheckUserDistributorR2Ok();

    if (this.userModel == undefined || !this.conditionsAccept || !this.userR1) {
      return userInfo$.pipe(combineLatestWith(checkConditions$, checkUserR1$, checkUserR2Ok$)).pipe(map(([userData, allowed, userR1, userR2Ok]) => {
        this.userModel = userData;
        this.conditionsAccept = allowed;
        this.userR1 = userR1;
        this.userR2Ok = userR2Ok;
        return this.checkRoute(route, state);
      }),
        catchError((err) => {
          console.error(err);
          this.router.navigate(['/home']);
          return of(false);
        }));
    } else {
      return this.checkRoute(route, state);
    }
  }

  checkRoute(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

    if (!this.userR2Ok) {
      this.router.navigate(['/check-user-R2-ok']);
      return false;
    }

    if (!this.conditionsAccept) {
      this.router.navigate(['/conditions-accept']);
      return false;
    }

    if (!this.userR1) {
      this.router.navigate(['/check-user-R1']);
      return false;
    }

    if (route.data["excludeRoles"]) {
      const excludeList = route.data["excludeRoles"].toString().split(",");
      const excluded = this.userModel.RolesListString.every(r => excludeList.indexOf(r) >= 0);
      if (excluded) {
        this.router.navigate(['/home']);
        return false;
      }
    }

    if (route.data["roles"]) {
      let rolValid = false;
      if (route.data["roles"].toString().split(",").some(r => this.userModel.RolesListString.indexOf(r) >= 0)) {
        rolValid = true;
      }
      if (rolValid === false) {
        this.router.navigate(['/home']);
        return false;
      }
    }
    return true;
  }

}
